<template>
  <b-card>
    <b-card-body>
      <b-card-title>Заметки</b-card-title>
      <b-card-sub-title>Заметки оставленные при замере</b-card-sub-title>
    </b-card-body>
    <b-card-body>
      <app-timeline>
        <app-timeline-item v-for="item in notesData">
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>
            <small class="text-muted mb-1">{{item.note.subject}}</small><br>
            {{item.note.title}}
          </h6>
          <small class="text-muted">{{item.note.created}}</small>
        </div>
        <p>{{item.note.content}}</p>
        <div class="d-flex">
          <b-media v-for="att in item.note.attachment" vertical-align="center">
            <b-link
                :href="att.attachment.upload_file "
                target="_blank"
                class="font-weight-bold text-nowrap media-body mb-0"
                v-b-tooltip.hover.top="att.attachment.name"
              >
                <b-img :src="require('@/assets/images/icons/doc.png')" height="23"/>
              </b-link>
          </b-media>
        </div>
      </app-timeline-item>
    </app-timeline>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, BImg, BMedia, BLink, VBTooltip
} from 'bootstrap-vue'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'


export default {
  components: {
    BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox, BImg, BMedia, BLink, VBTooltip,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    notesData: {
      type: Array,
      required: true,
    },
  },
    directives: {
    'b-tooltip': VBTooltip,
  },

}
</script>

<style>

</style>
